import * as React from 'react';
import * as AppMicWidgetStyle from './AppMicWidget.styles';
import { FontIcon, mergeStyles } from 'office-ui-fabric-react';
import { AppMicWidgetProps, AppMicWidgetRecorderState } from './AppMicWidget.props';

export class AppMicWidget extends React.PureComponent<AppMicWidgetProps> {

  constructor(props: AppMicWidgetProps) {
    super(props);
  }

  public render() {
    const appMicWidget = this._getAppMicWidget();

    return (
      <div style={AppMicWidgetStyle.getMicWidgetContainerCSSProperties()}>
        {appMicWidget}
      </div>
    );
  }

  private _getAppMicWidget() {
    // At present no pulsing animations is supported and hence return mic widget without pulsing.
    let appMicWidget = this._getMicWidgetWithoutPulsing();
    return appMicWidget;
  }

  private _getMicWidgetWithoutPulsing() {
    const { isEnabled, currentMicState } = this.props;

    const mergedStyle = this._getMergedStyleForMicWidget(isEnabled, currentMicState);
    const fontIconName = this._getFontIconNameForMicWidget(currentMicState);

    return (
      <button aria-labelledby="RecordingStatusLabel" className={mergedStyle} onClick={this._onMicWidgetClicked}>
        <FontIcon iconName={fontIconName} className={AppMicWidgetStyle.getMicWidgetIconStyles(fontIconName)} />
      </button>
    );
  }

  private _getMergedStyleForMicWidget(isEnabled: boolean, currentMicState: AppMicWidgetRecorderState) {
    let style = AppMicWidgetStyle.getMicWidgetStyle();

    if (isEnabled) {
      style = mergeStyles(style, AppMicWidgetStyle.getEnabledMicWidgetStyle());
    } else {
      style = mergeStyles(style, AppMicWidgetStyle.getDisabledMicWidgetStyle());
    }

    style = mergeStyles(style, this._getPartialStyleForMicWidgetInCurrentState(currentMicState));

    return style;
  }

  private _getPartialStyleForMicWidgetInCurrentState(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return AppMicWidgetStyle.getRecordingMicWidgetStyle();

      case AppMicWidgetRecorderState.Paused:
        return AppMicWidgetStyle.getPausedMicWidgetStyle();

      default:
        return AppMicWidgetStyle.getPausedMicWidgetStyle();
    }
  }

  private _getFontIconNameForMicWidget(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return AppMicWidgetStyle.RecordingStateIconName;

      case AppMicWidgetRecorderState.Paused:
        return AppMicWidgetStyle.PausedStateIconName;

      default:
        return AppMicWidgetStyle.PausedStateIconName;
    }
  }

  private _onMicWidgetClicked = async (): Promise<void> => {
    const { onMicWidgetClicked } = this.props;

    if (onMicWidgetClicked) {
      onMicWidgetClicked();
    }
  };
}